module.exports = __webpack_public_path__ + "img/services_corporate_xs.8fce5463.png";